import React from 'react';
import { View, StyleSheet } from 'react-native';
import { PAYMENT_DESIGN_TOKENS } from '@/constants/residents/mobile/paymentDesignTokens';
import { RESIDENTS_SVG_COMPONENTS } from '@/assets/residents';
import { mobilePaymentsStrings } from '@/constants/residents/strings';
import type { PaymentStatus } from '@/features/payments/hooks/useLeaseHistory';

// SVG Icon components
const PendingCheckIcon = RESIDENTS_SVG_COMPONENTS.PENDING_CHECK;
const SuccessCheckIcon = RESIDENTS_SVG_COMPONENTS.SUCCESS_CHECK;
const XFailedIcon = RESIDENTS_SVG_COMPONENTS.X_FAILED;

/**
 * Get the display label for a payment status
 */
export const getStatusLabel = (status: PaymentStatus | undefined): string => {
  switch (status) {
    case 'pending':
      return mobilePaymentsStrings.statusPending;
    case 'successful':
      return mobilePaymentsStrings.statusSuccessful;
    case 'declined':
      return mobilePaymentsStrings.statusDeclined;
    default:
      return '';
  }
};

/**
 * Get the text color for a payment status
 */
export const getStatusTextColor = (status: PaymentStatus | undefined): string => {
  switch (status) {
    case 'successful':
      return PAYMENT_DESIGN_TOKENS.SUCCESS_GREEN;
    case 'declined':
      return PAYMENT_DESIGN_TOKENS.ERROR_RED;
    case 'pending':
    default:
      return PAYMENT_DESIGN_TOKENS.TEXT_PRIMARY;
  }
};

/**
 * Render the status icon with appropriate background styling
 */
export const renderStatusIcon = (status: PaymentStatus | undefined): React.ReactNode => {
  switch (status) {
    case 'pending':
      return PendingCheckIcon ? (
        <View style={statusStyles.statusIconContainer}>
          <PendingCheckIcon width={20} height={20} />
        </View>
      ) : null;
    case 'successful':
      return SuccessCheckIcon ? (
        <View style={statusStyles.statusIconContainer}>
          <SuccessCheckIcon width={20} height={20} color={PAYMENT_DESIGN_TOKENS.SUCCESS_GREEN} />
        </View>
      ) : null;
    case 'declined':
      return XFailedIcon ? (
        <View style={statusStyles.statusIconContainerDeclined}>
          <XFailedIcon width={10} height={10} />
        </View>
      ) : null;
    default:
      return null;
  }
};

/**
 * Shared styles for status icon containers
 */
export const statusStyles = StyleSheet.create({
  statusIconContainer: {
    width: 21,
    height: 21,
    borderRadius: 20,
    backgroundColor: 'rgba(238, 241, 244, 0.08)', // Figma: bg-[rgba(238,241,244,0.08)]
    justifyContent: 'center',
    alignItems: 'center',
  },
  statusIconContainerDeclined: {
    width: 21,
    height: 21,
    borderRadius: 20,
    backgroundColor: 'rgba(255, 62, 62, 0.14)', // Figma: bg-[rgba(255,62,62,0.14)] - red tinted for declined
    justifyContent: 'center',
    alignItems: 'center',
  },
});
